<template>
  <img
    ref="image-ref"
    class="image"
    :loading="loading"
    :width="width"
    :height="height"
    :src="src"
    :title="alt"
    :alt="alt"
    @error="onError"
  >
</template>

<script lang="ts" setup>
import type { ImageSize } from '~/types/common'

type Props = {
  path?: string
  name?: string | null
  alt?: string
  size?: ImageSize
  errorDefault?: boolean
  defaultCategory?: boolean
  width?: string | number
  height?: string | number
  loading?: "lazy" | "eager" | undefined
}

const props = withDefaults(defineProps<Props>(), {
  size: 'full',
  loading: 'lazy',
  width: '',
  height: '',
  path: '',
  name: null,
  alt: ''
})

const imageRef = useTemplateRef<HTMLImageElement>('image-ref')

const src = computed(() => {
  if (props.path) {
    return props.path
  }

  if (!props.name) {
    return getDefaultImage()
  }

  return getImagePath({ name: props.name, size: props.size })
})

const onError = (event: any) => {
  if (event.target && props.defaultCategory && imageRef.value) {
    imageRef.value.src = getDefaultImageCategory()
    return
  }

  const nameImage: string = props.errorDefault || props.name === null ? '' : props.name

  handleErrorImg({
    event,
    image: nameImage
  })
}
</script>

<style lang="scss">
.image {
  pointer-events: none;
  object-fit: contain;
  object-position: center;
}
</style>
